<div *ngIf="quoteData">

    <!-- ══ Quote Details ══ -->
    <h4><u>Quote Details</u></h4>
    <div class="row">
        <div class="col-md-7">
            <div class="row mb-3">
                <div class="col-md-6"><label>Cover From:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.inception_date | date:'dd-MM-yyyy'" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Cover To:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="CoverTo | date:'dd-MM-yyyy'" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Product:</label></div>
                <div class="col-md-6">
                    <input type="text" value="Agricultural Vehicle" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Broker:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quote?.company_name || 'Peliwica Limited'" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Rating Type:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.rating_type | uppercase" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Transaction Date:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quote?.transactional_date | date:'dd-MM-yyyy'" class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>
    </div>

    <!-- ══ Proposer Details ══ -->
    <h4 class="mt-3"><u>Proposer Details</u></h4>
    <div class="row" *ngIf="quoteData.proposer">
        <div class="col-md-7">
            <div class="row mb-3">
                <div class="col-md-6"><label>Customer Type:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.proposer_type | titlecase" class="form-control form-control-sm" readonly>
                </div>
            </div>

            <!-- Company -->
            <div *ngIf="quoteData.proposer.proposer_type == 'company'">
                <div class="row mb-3">
                    <div class="col-md-6"><label>Company Name:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.company_name | titlecase" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Trading Name:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.trading_name | titlecase" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Company Registration:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.company_registration_number" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Year Established:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.year_established" class="form-control form-control-sm" readonly>
                    </div>
                </div>
            </div>

            <!-- Individual -->
            <div *ngIf="quoteData.proposer.proposer_type == 'individual'">
                <div class="row mb-3">
                    <div class="col-md-6"><label>Title:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.title | titlecase" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>First Name:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.first_name | titlecase" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Last Name:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.last_name | titlecase" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Date of Birth:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.dob | date:'dd-MM-yyyy'" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Type of Licence:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.licence_type" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Length Licence Held:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quoteData.proposer.licence_length | date:'dd-MM-yyyy'" class="form-control form-control-sm" readonly>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-md-6"><label>Agricultural Trade:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.agricultural_trade || quoteData.agricultural_trade" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Contracting %:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.contracting_percentage || quoteData.contracting_percentage" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Vehicles Used for Business?</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.business_use_declaration || quoteData.business_use_declaration" class="form-control form-control-sm" readonly>
                </div>
            </div>

            <!-- Address -->
            <h6 class="mt-2"><u>Address Details</u></h6>
            <div class="row mb-3">
                <div class="col-md-6"><label>Address Line 1:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.address?.line1" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Address Line 2:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.address?.line2" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Town:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.address?.town || quoteData.proposer.address?.town_county" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>County:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.address?.county" class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Postcode:</label></div>
                <div class="col-md-6">
                    <input type="text" [value]="quoteData.proposer.address?.postcode" class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>
    </div>

    <!-- ══ Convictions ══ -->
    <div *ngIf="quoteData.proposer?.convictions && quoteData.proposer.convictions.length > 0">
        <h4 class="mt-3"><u>Convictions</u></h4>
        <div class="row">
            <div class="col-md-7">
                <div *ngFor="let conv of quoteData.proposer.convictions; let i = index">
                    <h6><u>Conviction {{ i + 1 }}</u></h6>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Conviction Code:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="conv.code" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Conviction Date:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="conv.date | date:'dd-MM-yyyy'" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Number of Points:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="conv.points" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Months Banned:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="conv.banned" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Fine:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="conv.fine | number:'1.2-2'" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ══ Claims ══ -->
    <div *ngIf="quoteData.proposer?.claims && quoteData.proposer.claims.length > 0">
        <h4 class="mt-3"><u>Claims</u></h4>
        <div class="row">
            <div class="col-md-7">
                <div *ngFor="let clm of quoteData.proposer.claims; let i = index">
                    <h6><u>Claim {{ i + 1 }}</u></h6>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Date of Claim:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="clm.date | date:'dd-MM-yyyy'" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Type of Incident:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="clm.type || clm.incident_type" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>AD Claim Cost:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="clm.ad_cost | number:'1.2-2'" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>TP Claim Cost:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="clm.tp_cost | number:'1.2-2'" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Total Claim Cost:</label></div>
                        <div class="col-md-6">
                            <input type="text" [value]="(clm.ad_cost + clm.tp_cost) | number:'1.2-2'" class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Was the Driver at Fault?</label></div>
                        <div class="col-md-6">
                            <mat-radio-group class="row" disabled>
                                <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="true" [checked]="clm.fault === true || clm.at_fault === 'Yes'">Yes</mat-radio-button></div></div>
                                <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="false" [checked]="clm.fault === false || clm.at_fault === 'No'">No</mat-radio-button></div></div>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6"><label>Is the Claim Still Open?</label></div>
                        <div class="col-md-6">
                            <mat-radio-group class="row" disabled>
                                <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="true" [checked]="clm.open === true || clm.is_open === 'Yes'">Yes</mat-radio-button></div></div>
                                <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="false" [checked]="clm.open === false || clm.is_open === 'No'">No</mat-radio-button></div></div>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ══ Contact Details ══ -->
    <div *ngIf="quote && quote.is_send_email == 1">
        <h4 class="mt-3"><u>Contact Details</u></h4>
        <div class="row">
            <div class="col-md-7">
                <div class="row mb-3">
                    <div class="col-md-6"><label>Email:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quote?.email" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Phone:</label></div>
                    <div class="col-md-6">
                        <input type="text" [value]="quote?.phone" class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Preferred Ways to Hear:</label></div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-3">
                                <mat-radio-group class="row" disabled>
                                    <div class="quote_radio"><mat-radio-button value="1" [checked]="quote?.is_phone == 1">Phone</mat-radio-button></div>
                                </mat-radio-group>
                            </div>
                            <div class="col-md-3">
                                <mat-radio-group class="row" disabled>
                                    <div class="quote_radio"><mat-radio-button value="1" [checked]="quote?.sms == 1">Text</mat-radio-button></div>
                                </mat-radio-group>
                            </div>
                            <div class="col-md-3">
                                <mat-radio-group class="row" disabled>
                                    <div class="quote_radio"><mat-radio-button value="1" [checked]="quote?.is_email == 1">Email</mat-radio-button></div>
                                </mat-radio-group>
                            </div>
                            <div class="col-md-3">
                                <mat-radio-group class="row" disabled>
                                    <div class="quote_radio"><mat-radio-button value="1" [checked]="quote?.post == 1">Post</mat-radio-button></div>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
